<template>
  <div class="searchContent schMd">
    <div class="clueList">
      <div class="companyCardList">
        <el-table :data="list.tableData" style="width: 100%" :header-cell-style="{background: '#F5F6F8'}">
          <el-table-column prop="parkName" label="园区名称" min-width="180">
            <template slot-scope="scope">
              <span @click="clickLink(scope.row)"><textOverflow class="park-name">{{scope.row.parkName}}</textOverflow></span>
            </template>
          </el-table-column>
          <el-table-column prop="num" label="企业数量" min-width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row && scope.row.num > 0 ? Global.formatThousandSeparator(scope.row.num) : 0}}
            </template>
          </el-table-column>
          <div class="emptyBox" slot="empty">
            <div class="emptyBox-box">
              <div class="empty-ordinary">
                <img src="@/assets/emptyBox.svg" alt="" srcset="">
                <p class="center">暂无数据</p>
              </div>
            </div>
          </div>
        </el-table>
      </div>
    </div>
    <pagination v-if="list.tableData.length" :pageNum="list.pageNum" :pageSize="list.pageSize" :total="list.total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange" :key="list.pageNum" />
  </div>

</template>

<script>
import pagination from '@/components/pagination/'

export default {
  name: 'companyCardList',
  components: {
    pagination
  },
  props: {
    list: {
      type: Object,
      default () {
        return {
          pageNum: 1,
          pageSize: 20,
          total: 0,
          tab: 1,
          tableData: []
        }
      }
    },
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  mounted(){
  },
  methods: {
    clickLink(val) {
      const routeUrl = this.$router.resolve({
        path: '/zxk/junbros/parkInfo',
        query: {
          parkId: val.parkId,
          parkName: val.parkName,
          province: val.province,
          city: val.city
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    handleSizeChange(val){
      this.$emit('handle-page-num', val)
    },
    handleCurrentChange (val) {
      this.$emit('handle-page', val)
    },
  }
}
</script>
<style lang="scss" scoped>
.searchContent {
  background-color: #fff;
  margin-bottom: 24px;
  box-shadow: 0px 1px 5px 0px rgba(38,38,38,0.1000);
  border-radius: 4px 4px 0px 0px;
}
.pagination{
  padding-top: 24px;
}
.park-name {
  color: #5088ff;
  cursor: pointer;
}
.companyCardList {
  ::v-deep .el-table .el-table__cell:first-child{
    padding-left: 20px;
  }
  .emptyBox {
    text-align: center;
    padding: 100px;
    .emptyBox-box {
      display: flex;
      justify-content: center;
      .empty-ordinary {
        img {
          width: 150px;
          margin-bottom: -20px;
        }
        p {
          color: #999999;
        }
      }
    }
  }
}
</style>
